import SizingStepper from "./SizingStepper";
import { useDispatch, useSelector } from "react-redux";
import SizingDefineMechanics from "./SizingDefineMechanics";
import SizingDefineDynamics from "./SizingDefineDynamics";
import SizingGearBoxSelection from "./SizingGearBoxSelection";
import SizingResults from "./SizingResults";
import { selectRetrofitSizingCurrentStep, setIsSizingSelected } from "../store/slices/retrofit";
import { STEPS } from "../../Common/store/data/commonData";
import CustomPopup from "../../Common/components/CustomPopup/CustomPopup";
import DevicesHeader from "../../Retrofit/components/Devices/DevicesHeader";

const RetrofitSizing = ({ showSizing, setShowSizing }) => {
  const dispatch = useDispatch();
  const currentSizingStep = useSelector(selectRetrofitSizingCurrentStep);

  const displayCurrentStep = () => {
    switch (currentSizingStep) {
      case STEPS.RETROFIT_SIZING.DEFINE_MECHANICS:
        return <SizingDefineMechanics />;
      case STEPS.RETROFIT_SIZING.DEFINE_DYNAMICS:
        return <SizingDefineDynamics />;
      case STEPS.RETROFIT_SIZING.GEARBOX_SELECTION:
        return <SizingGearBoxSelection />;
      case STEPS.RETROFIT_SIZING.SIZING_RESULTS:
        return <SizingResults />;
      default:
        return <SizingDefineMechanics />;
    }
  };
  return (
    <CustomPopup
      fullScreen
      opened={showSizing}
      onClose={() => {
        setShowSizing(false);
        dispatch(setIsSizingSelected(false));
      }}
      headerTitle="Axis"
      highlightHeaderTitle
    >
      <div className="text-left space-y-3">
        <div className="pt-3">
          <DevicesHeader axis={{}} />
        </div>
        <SizingStepper />
        {displayCurrentStep()}
      </div>
    </CustomPopup>
  );
};

export default RetrofitSizing;
